export default {
  modifier: "ctrl",
  key: "s",
  action(editor) {
    editor.save();
  },
};
